import React from 'react';
import { ConfigureWorkflowBaseProps } from 'apps/sigma2-ui/src/components/workflows/types';
import { WriteBackToWorkdayViaWsJobApplicationCustomFieldPlaceToWrite } from 'libs/end-to-end/src/types/databases/workflows/strategies/workday-write-back';

export interface ConfigureWriteBackWorkdayViaWsJobApplicationCustomFieldPlaceToWriteProps
  extends ConfigureWorkflowBaseProps {
  placeToWrite: WriteBackToWorkdayViaWsJobApplicationCustomFieldPlaceToWrite;
  updatePlaceToWrite: (
    newPlaceToWrite: WriteBackToWorkdayViaWsJobApplicationCustomFieldPlaceToWrite,
  ) => void;
}

export const ConfigureWriteBackWorkdayViaWsJobApplicationCustomFieldPlaceToWrite =
  ({
    placeToWrite,
    updatePlaceToWrite,
  }: ConfigureWriteBackWorkdayViaWsJobApplicationCustomFieldPlaceToWriteProps) => {
    return (
      <div className="space-y-4 p-4 bg-white rounded shadow">
        <label className="block text-sm font-medium text-gray-700">
          Workday Custom Namespace
        </label>
        <input
          className="form-input mt-1 block w-full rounded-md border-gray-300 shadow-sm"
          type="text"
          value={placeToWrite.customNs ?? ''}
          onChange={(e) => {
            updatePlaceToWrite({
              ...placeToWrite,
              customNs: e.target.value,
            });
          }}
        />

        <label className="block text-sm font-medium text-gray-700">
          Workday Application Custom Field ID
        </label>
        <input
          className="form-input mt-1 block w-full rounded-md border-gray-300 shadow-sm"
          type="text"
          value={placeToWrite.customFieldKey ?? ''}
          onChange={(e) => {
            updatePlaceToWrite({
              ...placeToWrite,
              customFieldKey: e.target.value,
            });
          }}
        />

        <label className="block text-sm font-medium text-gray-700">
          Workday Custom Object Key (optional)
        </label>
        <p className="text-xs text-gray-500 mb-1">
          Leave empty to use the same value as Custom Field ID
        </p>
        <input
          className="form-input mt-1 block w-full rounded-md border-gray-300 shadow-sm"
          type="text"
          placeholder="Leave empty to use Custom Field ID"
          value={placeToWrite.customObjectKey ?? ''}
          onChange={(e) => {
            updatePlaceToWrite({
              ...placeToWrite,
              customObjectKey: e.target.value || undefined,
            });
          }}
        />
      </div>
    );
  };
